/* unplugin-vue-components disabled */import script from "./SmsModule.vue?vue&type=script&setup=true&lang=js"
export * from "./SmsModule.vue?vue&type=script&setup=true&lang=js"

import "./SmsModule.vue?vue&type=style&index=0&id=827c97ea&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-827c97ea"]])

export default __exports__